import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import globalStyles from "../../../global";
import ServiceToggle from "../servicesComponent/ServiceToggle";
import FAQSection from "../servicesComponent/FAQItem";
// import PromoSection from '../countryhomepagescomponent/PromoSection';
import { getResponsiveSize } from "../../../utils/responsive";
import Footer from "../../globalCountries/countryhomepagescomponent/Footer";
import News from "../../globalCountries/countryhomepagescomponent/News";
import CountryBorder from "../../globalCountries/countryhomepagescomponent/Countryborder";

const containerWidth = "1200px";

const CountryServices = () => {
  const { t, i18n } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const isRTL = i18n.language === "ar";
  const part3 = t("countryServices.heroTitle.part3");
  const [part3Word1, part3Word2] = part3.split(" ");
  const styles = {
    heroSection: {
      bgcolor: "#e0e7d8",
      height: {
        xs: "280px", // mobile
        sm: "440px", // tablets
        md: "500px", // laptops/desktops
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      width: "100%",
    },
    container: {
      display: "flex",
      flexDirection: {
        xs: "column",
        md: isRTL ? "row-reverse" : "row",
      },
      gap: 4,
      justifyContent: "center",
      alignItems: "center",
      maxWidth: containerWidth,
      mx: "auto",
      height: "100%", // Ensures child fills heroSection height
      overflow: "hidden", // Prevent image overflow
    },
    heroImage: {
      width: "50%",
      height: "100%",
      maxHeight: "100%",
      maxWidth: "100%",
      // Ensures image fits inside
      display: "block",
    },
    heroTextBox: {
      minWidth: "300px",
      px: 2,
      py: 6,
    },
    heroTitleContainer: {
      textAlign: "center",
      fontWeight: "bold",
      px: 4,
      py: 4,
      ml: isRTL ? 0 : { xs: 0, md: "-100px" },
      mr: isRTL ? { xs: 0, md: "-100px" } : 0,
    },
    heroTitle: {
      fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
      color: globalStyles.colors.army_green,
      fontFamily: globalStyles.fonts.primaryUAE,
    },
    greenText: {
      color: globalStyles.colors.uclean_green,
      display: "inline",
      fontFamily: globalStyles.fonts.primaryUAE,
    },
    heroSubtitle: {
      mt: { xs: 2, md: 4 },
      color: globalStyles.colors.uclean_green,
      fontSize: "inherit",
    },
    sectionTitle: {
      textAlign: "center",
      fontFamily: globalStyles.fonts.primaryUAE,
      fontWeight: 600,
      px: 4,
      fontSize: {
        md: "40px",
        sm: "28px",
        xs: "24px",
      },
      color: globalStyles.colors.army_green,
      textTransform: "uppercase",
      mb: 1,
    },
    sectionSubtitle: {
      textAlign: "center",
      fontFamily: globalStyles.fonts.primary,
      px: 4,
      fontSize: {
        sm: "20px",
        xs: "16px",
      },
      color: globalStyles.colors.light_gray,
      fontWeight: 400,
    },
    divider: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      mt: { xs: 8, md: 16 },
      mb: { xs: 8, md: 16 },
      bgcolor: globalStyles.colors.army_green,
      height: getResponsiveSize(200),
    },
  };

  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.heroSection}>
        <Box sx={styles.container}>
          <Box
            component="img"
            src={`${imageBaseUrl}countryServices.png`}
            alt={t("countryServices.heroTitle.part1")}
            sx={{
              ...styles.heroImage,
              verticalAlign: "bottom",
              display: {
                xs: "none",
                sm: "none",
                md: "block",
              },
            }}
          />
          <Box sx={styles.heroTextBox}>
            <Typography variant="h1" sx={styles.heroTitle}>
              {t("countryServices.heroTitle.part1") +
                " " +
                t("countryServices.heroTitle.part2")}{" "}
              <Box component="span" sx={styles.greenText}>
                {" "}
                {part3Word1} {part3Word2}
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ py: 8 }}>
        <Typography variant="h2" sx={styles.sectionTitle}>
          {t("countryServices.sectionTitle")}
        </Typography>
        <Typography sx={styles.sectionSubtitle}>
          {t("countryServices.sectionSubtitle")}
        </Typography>
        <ServiceToggle />
      </Box>
      <CountryBorder countryCode="uae" />
      {/* <PromoSection /> */}
      <FAQSection />
      <News />
      <Box sx={{ height: { sm: "80px", xs: "20px" } }} />
      <Footer />
    </Box>
  );
};

export default CountryServices;
